export const EN_TRANSLATIONS = {
	translation: {
		BUTTON_TEXT_PRE_APP: 'Send',
		DIAL_COUNTRY_SELECTOR: 'Country',
		COUNTRY_SELECTOR: 'Country',
		DOCUMENT_TYPE_SELECTOR: 'Select your document type',
		BUTTON_LOADING: '... Sending',
		TAB_TITLE: 'Latú - Business Insurance backed by Technology',
		PRE_APPLICATION_TAB_TITLE: 'Let’s cover your Business',
		STEPS_TITLE: 'Steps',
		NEXT: 'Next',
		BACK: 'Back',
		YES: 'Yes',
		NOT: 'No',
		COMPLETE: 'Complete',
		QUOTE_INTRO_1: `Great news! Here you will find the proposals we have made to fit your company's needs.`,
		QUOTE_INTRO_2: 'Insurance Product: ',
		QUOTE_INTRO_3: `Please select from the options below the proposal that best suits your needs. Each proposal offers different coverages.`,
		QUOTE_INTRO_RECOMMENDATION_LIMIT: 'Recommendation limit: ',
		QUOTE_COVERAGE_TITLE: 'Coverage:',
		QUOTE_COVERAGE_SUBTITLE:
			'This is the maximum amount the insurer will pay in the event of a claim',
		QUOTE_PREMIUM_TITLE: 'Premium:',
		QUOTE_PREMIUM_SUBTITLE: 'Amount to be paid for the coverage',
		QUOTE_COUNTRIES_COVERAGE_TITLE: 'Countries Covered:',
		QUOTE_CONTRACT_COVERAGES_TITLE: 'Contract Coverages:',
		QUOTE_EXCLUSIONS_TITLE: 'Exclusions:',
		QUOTE_ADDITIONAL_COVERAGES_TITLE: 'Additional Coverages:',
		QUOTE_OTHER_CONDITIONS_TITLE: 'Other Conditions:',
		QUOTE_PAYMENT_SCHEDULE_TITLE: 'Payment Schedule:',
		QUOTE_PAYMENT_SCHEDULE:
			'Up to 4 interest-free installments or 7 installments with an interest of 1.5% per month.',
		QUOTE_MORE_INFO:
			'At Latú, we are committed to helping you at every stage of your journey. If you need assistance or have any questions, simply send us a message or schedule a meeting - our team will be delighted to guide you.',
		QUOTE_SCHEDULE_MEET: 'Schedule a meeting',
		QUOTE_INSTALLMENTS_INFO:
			'{{numberOfInstallments}} installments of  {{value}}',
		QUOTE_SELECT_BUTTON: 'Confirm ',
		QUOTE_SUCCESS_MESSAGE:
			'Thank you for choosing us! Our team of insurance professionals will be in touch with you shortly to begin the process.',
		DENIED_TITLE: 'DENIED',
		DENIED_SUB_TITLE: 'The insurance company has denied access to a policy',
		MANDATORY_FIELD: 'Mandatory Field',
		YES_LABEL: 'Yes',
		NOT_LABEL: 'No',
		SUCCESS_TITLE: 'Thank You!',
		SUCCESS_SUB_TITLE: 'We will contact you soon.',
		SUCCESS_BUTTON_BACK: 'Back to home page',
		USER_TYPE_SELECTION_PAGE_TITLE: 'Introduce your business',
		USER_TYPE_SELECTION_PAGE_SUB_TITLE:
			"Hello! It's great to have you here. To start, let us know:",
		USER_TYPE_SELECTION_PAGE_PJ_SELECTION: 'I am a company',
		USER_TYPE_SELECTION_PAGE_PJ_SELECTION_DESC:
			'I am a company with CNPJ looking for insurance',
		USER_TYPE_SELECTION_PAGE_PF_SELECTION: 'I am an individual',
		USER_TYPE_SELECTION_PAGE_PF_SELECTION_DESC:
			'I am an individual with CPF looking for insurance',
		PLACEHOLDER_FULL_NAME: 'Full name',
		HOME: 'Home',
		HOME_PAGE_MENU: 'Home page',
		COVERAGE_PAGE_MENU: 'Latú Products',
		QUOTES_PAGE_MENU: 'Quotes',
		PROFILE_SETTINGS_MENU: 'Configurações de perfil',
		HELP_CENTRAL_MENU: 'Help center',
		LOGOUT_MENU: 'Log out',
		LOGOUT_MENU_CANCEL: 'Cancel',
		LOGOUT_CONFIRMATION: 'Are you sure you want to log out?',
		BANNER_INFO_EXPERIENCE_TO_TAKE_RISKS:
			'Experience the peace of being able to take risks.',
		BANNER_INFO_CA_QUOTE_NOW: 'Quote now',
		ALERT_INFO_COVERAGE_YOUR_NEEDS:
			"Don't know which insurance fits your needs?",
		ALERT_INFO_CA_FIND_OUT_HERE: 'Find out here',
		COVERAGE_PAGE_TITLE: 'What insurance are you looking for?',
		COVERAGE_PAGE_SUB_TITLE:
			'To bring you the best option, select one or more insurances that your company needs.',
		DYO_CARD_TITLE: 'Director & Officers',
		DYO_CARD_DESCRIPTION:
			'Protection for managers before claims related to your administration.',
		PROFESSIONAL_RESPONSIBILITY_CARD_TITLE: '-------',
		PROFESSIONAL_RESPONSIBILITY_CARD_DESCRIPTION:
			'Covers your business against losses suffered by clients that claims mistakes in your service',
		CYBER_CARD_TITLE: '-----',
		CYBER_CARD_DESCRIPTION:
			'Protection against cyber threats as hacker attacks and data leak.',
		CARD_TEXT_BUTTON_CALLBACK: 'Select',
		CARD_TEXT_LINK_CALLBACK: 'More information',
		MODAL_WANT_TO_TALK_TITLE: 'How do you want to talk with our team?',
		MODAL_WANT_TO_TALK_SUB_TITLE:
			'We are here to help you! Choose the best way to contact:',
		MODAL_WANT_TO_TALK_WHATSAPP_TITLE: 'WhatsApp',
		MODAL_WANT_TO_TALK_WHATSAPP_INFO: 'Talk with our specialized team',
		MODAL_WANT_TO_TALK_SCHEDULED_TITLE: 'Book a meeting',
		MODAL_WANT_TO_TALK_SCHEDULED_INFO:
			'Talk to us and have all your doubts cleared.',
		MODAL_WANT_TO_TALK_EMAIL_INFO: 'Get in touch with our team of experts',
		SIDEBAR_COMPANY_INFORMATION_TITLE: 'Company information',
		SIDEBAR_LABEL_COMPANY_NAME: 'Company name',
		SIDEBAR_LABEL_FULL_NAME: 'Employee name',
		SIDEBAR_LABEL_EMAIL: 'Employee e-mail',
		SIDEBAR_LABEL_WEBSITE: 'Company website',
		SIDEBAR_LABEL_ADMIN_EMAIL: 'Administrator name',
		SIDEBAR_LABEL_ADMIN_FULL_NAME: 'Administrator e-mail',
		SIDEBAR_COMPANY_INFORMATION_EDIT_BUTTON: 'Edit data',
		ALERT_INFO_HAS_INSURANCE: 'Has insurance with Latú',
		ALERT_INFO_DONT_HAS_INSURANCE: 'Has no insurance with Latú',
		DRAG_AND_DROP_FILE_TEXT: 'Drag and drop file here',
		TOTAL_EMPLOYEES_COPY: 'Total employees',
		IPAF_TAB_TITLE: 'Application Form',
		FINISH: 'Finish',
		SUCCESS_UPLOAD_FILE:
			'We have received your file now you can continue with the process',
		IPAF_SUCCESS_TITLE: 'Thank you for the informations',
		IPAF_SUCCESS_SUBTITLE:
			'We will work to deliver a quote for your business as soon as possible.',
		IPAF_SUCCESS_DETAIL_TITLE: 'Waiting time',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_1:
			'The analysis process takes 10 to 15 business days.',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_2:
			'Don\'t worry, we will keep you updated on all the news regarding the process!"',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_3: 'Understand the hiring process:',
		IPAF_SUCCESS_STEP_1: 'Filling out data',
		IPAF_SUCCESS_STEP_2: 'Quotation analysis',
		IPAF_SUCCESS_STEP_3: 'Presentation of quotation proposal',
		IPAF_SUCCESS_STEP_4: 'Active coverage',
		IPAF_SUCCESS_STEP_HERE: 'You are here!',
		ERROR_NAME_EMPTY: "The name can't be empty",
		LINK_ADDITIONAL_UPLOAD_COPY: 'Template for you to copy and edit',
		TALK_WITH_EXPERT_TITLE: 'Talk with your insurance expert',
		TALK_WITH_EXPERT_COPY: 'Count on personalized service for your account',
		ALL_SET_TITLE: 'Activate Your Account',
		ALL_SET_COPY:
			'Please click on the link we’ve sent to {{email}} to verify your account and continue.',
		PO: 'Portuguese',
		SP: 'Spanish',
		ES: 'Spanish',
		EN: 'English',
		BR: 'Brazil',
		MX: 'Mexico',
		CO: 'Colombia',
		US: 'United States',
		IPAF_PENDING_ALERT_TITLE: 'You have a form in progress.',
		IPAF_PENDING_ALERT_INTRO:
			'Complete the form and get the insurance quote for your business.',
		IPAF_PENDING_ALERT_TEXT_CALL_TO_ACTION: 'Finish form',
		MODAL_IPAF_CONFIRMATION_TITLE: 'Are you sure you want to finish later?',
		MODAL_IPAF_CONFIRMATION_SUB_TITLE: 'Your progress will be saved.',
		MODAL_IPAF_CONFIRMATION_BUTTON_CONTINUE: 'Continue filling',
		MODAL_IPAF_CONFIRMATION_BUTTON_SAVE: 'Finish later',
		LIGHT_TABLE_TITLE: 'Your processes by status',
		LIGHT_TABLE_HEADER_PROCESS_NAME: 'Name',
		LIGHT_TABLE_HEADER_UPDATED_AT: 'Last update',
		LIGHT_TABLE_HEADER_STATUS: 'Status',
		LIGHT_TABLE_HEADER_ACTION: 'Action',
		IPAF_STATUS_IN_PROGRESS: 'In Progress',
		IPAF_STATUS_PENDING_REVIEW: 'In Progress',
		IPAF_STATUS_EXPIRED: 'Expired',
		IPAF_STATUS_QUOTING: 'Quoting',
		IPAF_STATUS_QUOTE_READY: 'Quote Ready',
		LIGHT_TABLE_LINK_ACTION_CONTINUE: 'Continue',
		LIGHT_TABLE_LINK_ACTION_VIEW_EDIT_QUESTIONS: 'Continue',
		LIGHT_TABLE_LINK_ACTION_VIEW_QUOTE: 'View quote',
		SELECT_PRODUCT_COPY: 'Select product',
		ACTION_CLOSE_FROM_SUCCESS_PAGE: 'Close',
		QUESTION_CONFIRMATION_WELCOME_TITLE:
			'Welcome to Latu’s business insurance form.',
		QUESTION_CONFIRMATION_INFO:
			'Before filling out our form, check out these 3 great tips:',
		QUESTION_CONFIRMATION_CAPTION:
			"*If you need to, use the back button to review questions you've already answered.",
		QUESTION_CONFIRMATION_SECURE_DATA_TITLE: 'Your data will be safe:',
		QUESTION_CONFIRMATION_SECURE_DATA_SUB_TITLE:
			'We take security seriously and have implemented all measures to ensure the confidentiality and security of your information.',
		QUESTION_CONFIRMATION_NEEDS_TITLE: 'Your information will always be saved.',
		QUESTION_CONFIRMATION_NEEDS_SUB_TITLE:
			'We will find the best solution for your company, and for that, we need some information. If you need to stop, your progress will be saved, and you can continue later from where you left off.',
		QUESTION_CONFIRMATION_WE_ARE_FOR_YOU_TITLE:
			"We're here for whatever you need:",
		QUESTION_CONFIRMATION_WE_ARE_FOR_YOU_SUB_TITLE:
			'Our team is always available, and we will be happy to help or answer any questions you may have. Click the chat button if you have any questions during the process.',
		QUESTION_CONFIRMATION_BUTTON_CONTINUE: 'Next',
		QUESTION_CONFIRMATION_BUTTON_START: 'Start',
		WELCOME_MESSAGE: 'Welcome',
		CONFIRMATION_MODAL_START_NEW_IPAF_TITLE:
			'You already have a process underway',
		CONFIRMATION_MODAL_START_NEW_IPAF_INTRO:
			'If you start a new process, the current information will be lost.',
		CONFIRMATION_MODAL_START_NEW_IPAF_INTRO_1:
			'will be replaced by this new one.',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_TO_CONTINUE:
			'Do you want to continue?',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_BUTTON_ACTION_CONTINUE_OLD:
			'Continue the current process',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_BUTTON_ACTION_CONTINUE_NEW:
			'Start a new process',
		BUTTON_START_NEW_IPAF: 'Start',
		ANSWER_PAGE_TITLE: 'Review Your Answers',
		ANSWER_PAGE_INTRO:
			'Ensure that all information is correct before finalizing. This information will be used to provide the appropriate insurance coverage for your business.',
		ANSWER_PAGE_BUTTON: 'Next',
		COVERAGE_DETAIL_PAGE_BACK_TO_HOME_LINK:
			'Go back to the initial Quotes page',
		COVERAGE_DETAIL_PAGE_TITLE: 'Quotes for: {{insurance_name}}',
		COVERAGE_DETAIL_PAGE_SUB_TITLE:
			'Select the quote that makes sense for your company:',
		COVERAGE_DETAIL_PAGE_BANNER_TITLE: 'What is {{insurance_name}}?',
		COVERAGE_DETAIL_PAGE_BANNER_SUB_TITLE: '',
		COVERAGE_DETAIL_PAGE_BANNER_MORE_INFO: 'Want to learn more?',
		COVERAGE_DETAIL_PAGE_BANNER_CLICK_INFO: 'Click here',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGE_TEXT: 'Coverage',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGE_SELECTED_TEXT:
			'The maximum compensation provided by the insurer in the event of a claim is {{coverage_selected}}.',
		COVERAGE_DETAIL_PAGE_QUOTE_GROSS_TEXT: 'Gross premium',
		COVERAGE_DETAIL_PAGE_QUOTE_EXPIRED_TEXT: 'Quote expires in:',
		COVERAGE_DETAIL_PAGE_QUOTE_AMOUNT_TO_PAID_TEXT:
			'Amount to be paid for the coverage',
		COVERAGE_DETAIL_PAGE_QUOTE_WITH_FEES_TEXT: 'with fees included',
		COVERAGE_DETAIL_PAGE_QUOTE_WITH_OUT_FEES_TEXT: 'plus taxes',
		COVERAGE_DETAIL_PAGE_QUOTE_SELECT_TEXT: 'Select quote',
		COVERAGE_DETAIL_PAGE_QUOTE_SELECTED_TEXT: 'Cotação selecionada',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGES_TEXT: 'Coverages',
		COVERAGE_DETAIL_PAGE_QUOTE_EXCLUSIONS_TEXT: 'Exclusions',
		COVERAGE_DETAIL_PAGE_QUOTE_MORE_TEXT: '+{{total_coverages}}',
		COVERAGE_DETAIL_PAGE_QUOTE_VIEW_MORE_DETAIL_TEXT: 'View more information',
		COVERAGE_DETAIL_PAGE_QUOTE_DOWNLOAD_FULL_COVERAGE_TEXT:
			'Download full quote',
		COVERAGE_DETAIL_PAGE_QUOTE_DO_YOU_NEED_HELP_TEXT:
			'Do you need help with the quotes?',
		COVERAGE_DETAIL_PAGE_QUOTE_SPEAK_AN_EXPERT_TEXT: 'Speak to an expert',
		QUOTE_RECOMMENDED_TEXT: 'Recommended',
		QUOTE_MODAL_MORE_INFO_TITLE: 'Information about the insurance',
		QUOTE_MODAL_COVERAGE_TITLE: 'Coverages',
		QUOTE_MODAL_EXCLUSIONS_TITLE: 'Exclusions',
		QUOTE_MODAL_PAYMENT_TITLE: 'Payment',
		QUOTE_MODAL_RETRO_ACTIVITY_TITLE: 'Retroactivity',
		QUOTE_MODAL_SCOPE_TITLE: 'Scope of coverage',
		QUOTE_MODAL_SUSEP_CODE_TITLE: 'Insurance code',
		QUOTE_MODAL_WE_NEED_TEXT:
			'We need to obtain a signature from a legal representative of the company to initiate the issuance process.',
		QUOTE_MODAL_DO_YOU_WANT_TEXT: 'Do you want to confirm the quote?',
		QUOTE_MODAL_CONTRACT_CALL_TO_ACTION_TEXT: 'Proceed with the contract',
		QUOTE_MODAL_CANCEL_TEXT: 'Cancel',
		QUOTE_SUCCESS_MODAL_TITLE: 'Congratulations on your choice!',
		QUOTE_SUCCESS_MODAL_INFO:
			'We will send an email to {{email}} to confirm the information provided and the selected',
		QUOTE_SUCCESS_MODAL_INTRO:
			'After the requested confirmation, we will initiate the issuance process in conjunction with the insurer. If no additional documentation or information is required, we expect to obtain the policy within 15 days.',
		EXPIRED: 'Expired',
		REMOVE: 'Remove',
		QUOTE_PAGE_TITLE: 'Quotes',
		QUOTE_PAGE_SUB_TITLE:
			'Check the available budgets and track the status of the quotes. The status will be updated whenever there is progress in the request.',
		QUOTE_PAGE_BANNER_TITLE: 'Do you need help with the quotes?',
		QUOTE_PAGE_BANNER_CALL_TO_ACTION: 'Speak to an expert',
		QUOTE_BLOCK_SEARCHING_QUOTE_TITLE: 'Looking for a quote',
		QUOTE_BLOCK_AVAILABLE_QUOTES_TITLE: 'Available quotes',
		QUOTE_BLOCK_EMISSION_QUOTES_TITLE: 'Quotes being issued',
		QUOTE_BLOCK_EXPIRED_QUOTES_TITLE: 'Expired quotes',
		QUOTE_CARD_PRODUCT_TITLE: 'Quotes for the product',
		QUOTE_CARD_APPLICATION_DATE_TEXT: 'Request date:',
		QUOTE_CARD_SEARCH_QUOTE_TEXT: 'Searching for a quote',
		QUOTE_CARD_EXPIRATION_DATE_TEXT: 'Quote expires on:',
		QUOTE_CARD_VIEW_DETAIL_LINK: 'View quotes',
		QUOTE_CARD_INSURER_TEXT: 'Insurer',
		QUOTE_CARD_MAXIMUM_COVERAGE_TEXT:
			'Maximum coverage amount in case of a claim',
		QUOTE_VALID_FOR: 'Quotes valid for:',
		EDIT: 'Edit',
		BACK_LINK: 'Back',
		QUOTE_PAGE_DONT_HAVE_QUOTES_TEXT:
			'We currently do not have any quotes available.',
		QUOTE_PAGE_START_YOUR_QUOTE_TEXT: 'Start your quote process right now.',
		QUOTE_PAGE_QUOTE_TEXT_BUTTON: 'Quote now',
		IPAF_STATUS_CLOSED: 'Completed',
		SIGN_IN_TEXT: 'Sign In',
		POLICIES_PAGE_MENU: 'My policies',
		POLICIES_PAGE_TITLE: 'My policies',
		POLICIES_PAGE_SUB_TITLE:
			'View and manage the policies contracted by your company',
		TAB_POLICY_ACTIVE: 'Active policies',
		TAB_POLICY_EXPIRED: 'Expired policies',
		PREAPP_LIST_ITEM_1:
			'Sign up to create your account and start the quoting process.',
		PREAPP_LIST_ITEM_2:
			'Manage everything related to your insurance with Latú.',
		ALREADY_ACCOUNT_TEXT: 'Do you already have an account?',
		ALREADY_ACCOUNT_TEXT_LINK: 'Log in',
		PAID: 'Paid',
		PENDING: 'Pending',
		LATE: 'Delayed',
		DELAYED: 'Delayed',
		IN_QUEUE: 'Pending',
		POLICY_CARD_POLICY_HOLDER: 'Policyholder',
		POLICY_CARD_INSURANCE_COMPANY: 'Insurance company',
		POLICY_CARD_INSURANCE_EXPIRATION: 'Expiration',
		POLICY_CARD_VIEW_POLICY_TEXT: 'View policy',
		POLICY_DETAIL_GENERAL_INFORMATION_TITLE: 'General information',
		POLICY_DETAIL_INSURANCE_NAME_TITLE: 'About {{insurance_name}}',
		POLICY_DETAIL_COVERAGES_AND_EXCLUSIONS_TITLE: 'Coverages and exclusions',
		POLICY_DETAIL_COVERAGE_TITLE: 'Insurance coverages',
		POLICY_DETAIL_COVERAGE_EXCLUSIONS_TITLE: 'Insurance exclusions',
		POLICY_DETAIL_DOWNLOAD_POLICY: 'Download full policy',
		POLICY_DETAIL_DETAIL_POLICY: 'View more details of the policy',
		POLICY_DETAIL_COVERAGE_LIMIT: 'Coverage limit',
		POLICY_DETAIL_TOTAL_COVERAGE: 'Total coverage',
		POLICY_DETAIL_SUB_LIMITS_TITLE: 'Be aware of sublimits!',
		POLICY_DETAIL_SUB_LIMITS_TEXT:
			'Sublimits restrict the maximum coverage amount for certain risks or damages. For more information, please check your policy.',
		POLICY_DETAIL_MAX_COVERAGE_INFO:
			'Maximum coverage amount in case of a claim',
		POLICY_DETAIL_PERIOD_INFO: 'Policy period',
		POLICY_DETAIL_EFFECTIVE_DATE: 'Effective date',
		POLICY_START_AND_END_DATE: 'Policy start and end date',
		POLICY_DETAIL_PLAN_ANNUAL: 'Annual plan',
		POLICY_DETAIL_PAYMENT_TITLE: 'Payment',
		POLICY_DETAIL_PAYMENT_SUB_TITLE: 'Track your insurance payments.',
		POLICY_DETAIL_TOTAL_AMOUNT_BE_PAID: 'Total amount to be paid:',
		POLICY_DETAIL_PAYMENT_TYPE: 'Payment method:',
		POLICY_DETAIL_NEXT_PAYMENT: 'Next payment due on:',
		POLICY_TABLE_INVOICE_TITLE: 'Invoices',
		POLICY_TABLE_EXPIRATION_TITLE: 'Due date',
		POLICY_TABLE_VALUE_TITLE: 'Amount',
		POLICY_TABLE_DOWNLOAD_TITLE: 'Download',
		POLICY_DETAIL_PAYMENT_STATUS_INFO: 'The payment status is updated weekly.',
		POLICY_DETAIL_REPORT_CLAIM_TEXT_A: 'Need to report a claim?',
		POLICY_DETAIL_REPORT_CLAIM_TEXT_B: "We're here to help!",
		POLICY_DETAIL_REPORT_CLAIM_LINK: 'Report a claim',
		COVERAGE_DETAIL_PAGE_POLICY_DOWNLOAD_FULL_COVERAGE_TEXT: 'Download policy',
		POLICY_DETAIL_DATA_ZERO_TEXT:
			'We are working to bring you your payment data. Soon, you will be able to track them here!',
		SELECTED_QUOTE_TEXT: 'Selected quote:',
		CLOSE_AND_REDIRECT_QUOTES_HOME: 'Go to quotes menu',
		COMPANY_STRUCTURE_ADD_BUTTON_TEXT: 'Add company',
		COMPANY_STRUCTURE_INFO_TEXT: 'You can add more than one client',
		COMPANY_REVENUE_DISTRIBUTION_INFO_TEXT: 'You can add more than one person',
		COMPANY_REVENUE_INDUSTRY_PERCENTAGE_INFO_TEXT:
			'Just fill in the ones that apply to your business',
		COMPANY_REVENUE_PERCENTAGE_INFO_TEXT:
			'Just fill in the ones that apply to your business',
		ADD_COMPANY_MEMBERS_TEXT: 'Add company members',
		ADD_COMPANY_TEXT: 'Add company',
		EDIT_COMPANY_TEXT: 'Edit company',
		BANNER_PROGRESS_IPAF_TITLE: 'You have an in-progress form!',
		BANNER_PROGRESS_IPAF_TEXT: 'Complete the form to receive your quote.',
		BANNER_PROGRESS_IPAF_CALL_TO_ACTION: 'Complete form',
		UNAVAILABLE_TEXT: 'Unavailable:',
		PURCHASE_INSURANCE_TITLE: 'Purchase an insurance',
		PURCHASE_INSURANCE_TEXT:
			'Start the process of acquiring your insurance quickly and easily.',
		AVAILABLE_QUOTES_TITLE: 'View available quotes',
		AVAILABLE_QUOTES_TEXT: 'Check out the available quotes at Latú!',
		AVAILABLE_QUOTES_UNAVAILABLE_TEXT:
			'Soon you will have access to the quotes for your insurance.',
		AVAILABLE_POLICY_TITLE: 'View available policies',
		AVAILABLE_POLICY_TEXT: 'Check your policies and payment status.',
		AVAILABLE_POLICY_UNAVAILABLE_TEXT:
			'You will be able to view your policies once your insurance is active.',
		VIEW_QUOTES_TEXT: 'View quotes',
		VIEW_POLICY_TEXT: 'View policies',
		ACTIVE_TAG_POLICY_COPY: 'Active coverage',
		CREATED_TAG_POLICY_COPY: 'Activation on {{startDate}}',
		EXPIRED_TAG_POLICY_COPY: 'Expired policy period',
		PENDING_PAYMENT_TAG_POLICY: 'Activation Pending Initial Payment',
		FORM_ADD_COMPANY_TITLE: 'Add company',
		CLAIMS_DETAIL_TITLE_PAGE: 'Claim',
		CLAIMS_PAGE_MENU: 'Claims',
		CLAIMS_TITLE_PAGE: 'Claims',
		CLAIMS_SUBTITLE_PAGE:
			'View the claims you have open and track the status of each one.',
		CLAIMS_CTA_TITLE: 'Report a claim.',
		CLAIMS_CTA_SUBTITLE: 'Fill in the claim details so we can assist you.',
		CLAIMS_TABLE_TITLE: 'Claims by status.',
		CLAIMS_TABLE_SUBTITLE: 'Track the status of your reported claims.',
		CLAIMS_TABLE_PROTOCOL: 'Protocol number',
		CLAIMS_TABLE_TYPE: 'Type of claim.',
		CLAIMS_TABLE_UPDATE: 'Last update',
		CLAIMS_TABLE_DOWNLOAD: 'View claim',
		CLAIMS_CREATE_TITLE: 'Report claim.',
		CLAIMS_CREATE_SUBTITLE: 'Please fill in the following information:',
		CLAIMS_CREATE_Mandatory: 'Required fields',
		CLAIMS_CREATE_TYPE:
			'Select the insurance you want to report the claim for:',
		CLAIMS_CREATE_SELECT: 'Select',
		CLAIMS_CREATE_SHORT_DESCRIPTION: 'Description of the incident:',
		CLAIMS_CREATE_CONTACT_NAME: 'Full name:',
		CLAIMS_CREATE_CONTACT_NAME_TEXT: 'Enter your full name:',
		CLAIMS_CREATE_CONTACT_EMAIL: 'E-mail:',
		CLAIMS_CREATE_CONTACT_EMAIL_TEXT: 'Enter a valid email:',
		CLAIMS_CREATE_CONTACT_TELEPHONE: 'Provide us with your contact number:',
		CLAIMS_CREATE_CONTACT_TELEPHONE_TEXT: 'Enter your mobile number:',
		CLAIMS_CREATE_CTA: 'Open claim',
		CLAIMS_DATA_ZERO_TEXT:
			"We couldn't find an active insurance policy associated with your account at the moment. Once you purchase an insurance policy with us, we'll be ready to assist in case of any claim.",
		CLAIMS_STATUS_PENDING: 'In progress',
		CLAIMS_STATUS_IN_PROGRESS: 'In progress',
		CLAIMS_STATUS_REJECTED: 'Closed',
		CLAIMS_STATUS_APPROVED: 'Approved.',
		CLAIMS_DETAILS_SUB_TITLE: 'Claim details',
		CLAIMS_DETAIL_FULL_NAME: 'Full name',
		CLAIMS_DETAIL_PHONE_CONTACT: 'Contact phone number',
		CLAIMS_DETAIL_EMAIL: 'Email',
		CLAIMS_DESCRIPTION_INCIDENT: 'Description of the incident',
		CLAIMS_DESCRIPTION_UPDATES_SUBTITLE: 'Updates',
		SUCCESS_SCREEN_TITLE: 'Your claim has been reported.',
		SUCCESS_SCREEN_SUBTITLE:
			'We have received your request. Please wait while we analyze it; we will get back to you as soon as possible.',
		SUCCESS_SCREEN_PRODUCT_TITLE: 'Product',
		SUCCESS_SCREEN_SUMMARY: 'Summary of the claim',
		SUCCESS_SCREEN_VIEW_CLAIM: 'View claim',
		SUCCESS_SCREEN_GO_BACK: 'Go to home page',
		FOOTER_SUPPORT: 'Support',
		FOOTER_SCHEDULE_INFO: 'Schedule a meeting',
		TOOLTIP_TITLE_SUBLIMITS: 'About the sublimit',
		TOOLTIP_INFO_SUBLIMITS:
			'Maximum limit within the insurance policy for specific coverages.',
		TOOLTIP_INFO_FRANQUIA:
			'Represents the amount of money a policyholder must pay out of pocket before their insurance coverage takes effect.',
		BUBBLE_WHATSAPP_INFO: 'Contact us via WhatsApp',
		BUBBLE_SCHEDULE_MEET_INFO: 'Schedule a meeting',
		USER_DISABLED: 'Active',
		USER_ENABLED: 'Inactive',
		USER_PENDING: 'Pending',
		ROL_COPY_ADMIN: 'Administrator',
		ROL_COPY_BROKER: 'Administrator',
		ROL_COPY_BROKER_INVITED: 'Team member',
		ROL_COPY_BROKER_CUSTOMER: 'Administrator',
		ROL_COPY_USER: 'Team member',
		REQUIRED_NAME: 'Name is required',
		REQUIRED_EMAIL: 'Email is required',
		INVALID_EMAIL: 'The email format is invalid',
		MENU_NAME: 'Team members',
		ROLES_TITLE: 'Team members',
		ROLES_SUBTITLE: "Invite or manage your team's coworkers",
		ROLES_MAIN_CTA: 'Invite members',
		ACCOUNT_OWNERSHIP: 'Account Administrator',
		ACCOUNT_OWNERSHIP_DISCLAIMER_1: 'To change the',
		ACCOUNT_OWNERSHIP_DISCLAIMER_2: 'administrator,',
		ACCOUNT_OWNERSHIP_DISCLAIMER_3: 'contact support.',
		PENDING_INVITATIONS_COPY: 'Pending Invitations',
		USER_NAMES: 'Full name',
		USER_EMAIL: 'Email',
		USER_ROLE: 'Permissions',
		USER_ACTIONS: 'Possible action',
		RE_SEND_INVITATION_BUTTON: 'Resend Invite',
		ADMIN_ROLE: 'Admin',
		TEAM_MEMBER_ROLE: 'Team member',
		REMOVE_USER_TITLE: 'Are you sure you want to remove this team member?',
		REMOVE_USER_SUBTITLE_1: 'The user',
		REMOVE_USER_INVITE_SUBTITLE_1: 'The invitee with the email address',
		REMOVE_USER_SUBTITLE_2:
			'will no longer have access to the Latú account. However, you can add the user again whenever you want',
		REMOVE_USER_INVITE_SUBTITLE_2:
			'will no longer have a pending invitation to the Latú account. Don’t worry, you can send a new invitation whenever you want.',
		REMOVE_USER_QUESTION: 'Do you want to remove the user?',
		REMOVE_USER_INVITE_QUESTION: 'Do you want to remove this invitee?',
		REMOVE_USER_CONFIRM: 'Remove user',
		REMOVE_USER_CANCEL: 'Cancel',
		REMOVE_USER_SUCCESS_1: 'The user',
		REMOVE_USER_SUCCESS_2: 'has been successfully removed!',
		ADD_VIEW_TITLE: 'Invite team members',
		ADD_VIEW_SUBTITLE:
			'Choose one or more members to compose your team by name and email.',
		ADD_VIEW_SUCCESS_TITLE: 'Members invited successfully!',
		ADD_VIEW_SUCCESS_SUBTITLE:
			'We will send an email to all added members so they can have immediate access to the Latú Corretores platform',
		ADD_VIEW_SUCCESS_SUBTITLE_TO_USER:
			'We will send an email to all added members so they can have immediate access to the Latú Seguros platform',
		ADD_VIEW_NAME_TITLE: 'Name',
		ADD_VIEW_NAME_PLACEHOLDER: 'Enter a valid name',
		ADD_VIEW_TEAM_EMAIL: 'email',
		ADD_VIEW_EMAIL_TITLE: 'Email',
		ADD_VIEW_EMAIL_PLACEHOLDER: 'Enter a valid email',
		ADD_VIEW_EMAIL_ROLE: 'Team member',
		ADD_VIEW_ADD_MORE: 'Add member',
		ADD_VIEW_CONFIRM_CTA: 'Invite member',
		ADD_VIEW_CONFIRM_CTA_MANY: 'Invite {{numMembers}} members',
		ADD_VIEW_CANCEL: 'Cancel',
		ADD_VIEW_SUCCESS_CTA: 'Understood',
		ADD_VIEW_SUCCESS_MESSAGE: 'Invitation sent successfully',
		ADD_VIEW_BACK_BUTTON: 'Back',
		ADD_VIEW_NO_ACCESS:
			'Sorry - Your current access level does not allow you to invite people.',
		REGISTER_SCREEN_TITLE: 'Welcome to Latú!',
		REGISTER_SCREEN_SUBTITLE: 'Enter your details to create an account',
		REGISTER_SCREEN_ACCOUNT_INFO_TITLE: 'Account information',
		REGISTER_SCREEN_ACCOUNT_INFO_EMAIL: 'Email address',
		REGISTER_SCREEN_ACCOUNT_INFO_COMPANY: 'Team/Organization',
		REGISTER_SCREEN_ACCOUNT_INFO_GOOGLE_LOGIN: 'Continue with Google',
		REGISTER_SCREEN_ACCOUNT_OPTION_TEXT: 'or log in with email',
		REGISTER_SCREEN_ACCOUNT_USERNAME: 'Full name',
		REGISTER_SCREEN_ACCOUNT_USERNAME_PLACEHOLDER: 'Enter your full name',
		REGISTER_SCREEN_ACCOUNT_PASSWORD: 'Create your password',
		REGISTER_SCREEN_ACCOUNT_PASSWORD_PLACEHOLDER: 'Enter your password',
		REGISTER_SCREEN_ACCOUNT_TERMS_CONDITIONS: 'I accept the Terms of Service',
		REGISTER_SCREEN_ACCOUNT_CTA: 'Signup',
		WELCOME_SCREEN_TITLE: 'Welcome to the Latú App!',
		WELCOME_SCREEN_SUBTITLE:
			"Within this hub, you'll be able to view your business policies, browse through quotes, and handle claims. It's your one-stop destination for all things insurance, putting you in the driver's seat like never before.",
		WELCOME_SCREEN_CTA: 'Understood',
		BANNER_PROGRESS_RENEWAL_IPAF_TITLE: 'You have policies about to expire!',
		BANNER_PROGRESS_RENEWAL_IPAF_TEXT:
			'Renew your policies and keep your company secure.',
		BANNER_PROGRESS_RENEWAL_IPAF_CALL_TO_ACTION: 'Renew policy',
		INFO_PERCENT_DEDUCTIBLE: 'of the losses',
		INFO_NO_DEDUCTIBLE: 'Insurance without deductible',
		INFO_NO_DEDUCTIBLE_TEMP:
			'10% of the losses, with a minimum of R$ 250,000.00',
		FRANQUIA_TITLE: 'Deductible (applies to any claim)',
		FRANQUIA_DEFINITION: 'Amount to be paid before coverage is provided.',
		MINIMUM_OF: 'Minimum of',
		REGULATORY_DISCLAIMER:
			'For a complete description and list of coverages, exclusions, and general definitions, please refer to the General Conditions of the Product.',
		REGULATORY_DISCLAIMER_LINK: 'Download general conditions.',
		INTRODUCTION_RENEWALS_MANTRA_A: 'Welcome to the insurance',
		INTRODUCTION_RENEWALS_MANTRA_B: 'renewal',
		INTRODUCTION_RENEWALS_MANTRA_C: 'process.',
		INTRODUCTION_RENEWALS_TITLE_A:
			'To renew your insurance policies, we need to',
		INTRODUCTION_RENEWALS_TITLE_B: 'update your information.',
		INTRODUCTION_RENEWALS_TITLE_C: "Don't worry,",
		INTRODUCTION_RENEWALS_TITLE_D:
			'the information collection process is completely streamlined!',
		INTRODUCTION_RENEWALS_SUBTITLE_PRODUCTS:
			'Insurance policies up for renewal:',
		INTRODUCTION_RENEWALS_SLIDER_TITLE: 'How does the renewal process work?',
		INTRODUCTION_RENEWALS_SLIDER_STEP1_TITLE:
			'Simplifying the process for you:',
		INTRODUCTION_RENEWALS_SLIDER_STEP1_TEXT:
			'We have updated the application to simplify the information submission, with most details already pre-filled. Our team will use this information to propose the best renewal for your business.',
		INTRODUCTION_RENEWALS_SLIDER_STEP2_TITLE:
			'Analysis of the new information and presentation of the proposal.',
		INTRODUCTION_RENEWALS_SLIDER_STEP2_TEXT:
			'We present a fully tailored proposal, including coverages, limits, conditions, and premiums. Once you choose the ideal proposal, we will start issuing the policy and payment documents. We will be available to clarify and ensure your full understanding of the proposal.',
		INTRODUCTION_RENEWALS_SLIDER_STEP3_TITLE: 'Renewed policy!',
		INTRODUCTION_RENEWALS_SLIDER_STEP3_TEXT:
			'After completing all procedures, you will be able to access your updated policy directly through the application.',
		INTRODUCTION_RENEWALS_REMINDER_TEXT_A: 'Reminder:',
		INTRODUCTION_RENEWALS_REMINDER_TEXT_B:
			'Before any of your current policies expire, our team will notify you.',
		INTRODUCTION_RENEWALS_START_BUTTON: 'Start renewal',
		REVIEW_ANSWER_TITLE:
			'Review your information below, and we will create your quote.',
		REVIEW_ANSWER_QUESTION: 'Question',
		REVIEW_ANSWER_ANSWER: 'Answer',
		REVIEW_ANSWER_EDIT: 'Edit',
		REVIEW_ANSWER_CONTINUE: 'Next',
		NO_FILE_ANSWER: 'No document has been attached.',
		CYBER_MODULE_TIERS_LITE: 'Latú Cyber Lite',
		CYBER_MODULE_TIERS_PLUS: 'Latú Cyber Plus',
		CYBER_MODULE_SUBSCRIBE_INTRO_TITLE: 'Latú Scan',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_1:
			'Take control of your cybersecurity with Latú Scan, the leading risk management tool adopted by organizations of all sizes. Gain visibility into your assets, identify vulnerabilities before potential attacks, and learn how to fix them.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_2: 'control of your cybersecurity',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_3: 'with',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_4: 'Latú Sonar',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_5:
			'the leading risk management tool adopted by organizations of all sizes. Gain',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_6: 'visibility of your assets,',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_7: 'identify',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_8: 'vulnerabilities',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_9:
			'before potential attacks, and learn how to',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_10: 'address them.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_11: 'Request your first assessment now!',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_12: 'Request assessment',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_TITLE: 'What do we analyze?',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_1:
			'Data assets (such as domains, IPs, and all 65 thousand ports)',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_2: 'Applications and Services',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_3: 'Data Leaks',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_4: 'Phishing Risk',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_BUTTON:
			'Watch the cybersecurity video.',
		CYBER_MODULE_SUBSCRIBE_FORM_TITLE: 'Request Cybersecurity Assessment.',
		CYBER_MODULE_SUBSCRIBE_FORM_SUBTITLE:
			'We just need a few details to conduct an assessment tailored to your business.',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN: 'Main Domain',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN_DESCRIPTION_1: 'Note:',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN_DESCRIPTION_2:
			'we will retrieve all subdomains and IP addresses associated with the listed domain for the cyber assessment.',
		CYBER_MODULE_SUBSCRIBE_FORM_ACTIVITY: 'Company activity.',
		CYBER_MODULE_SUBSCRIBE_FORM_COMPANY_SIZE: 'Number of employees.',
		CYBER_MODULE_SUBSCRIBE_FORM_COMPANY_REVENUE: 'Revenue from the last year.',
		CYBER_MODULE_SUBSCRIBE_FORM_BUTTON: 'Request evaluation.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_TITLE:
			'Request submitted successfully.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_TEXT:
			'We will notify you about the progress of your Cyber Assessment via email at',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BUTTON_REPORTS: 'Go to my reports.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BANNER_TITLE:
			"Now you can purchase Latú's Cyber Insurance.",
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BANNER_SUBTITLE:
			"You've progressed towards compliance. Explore our Cyber Insurance and take another step towards your company's cybersecurity!",
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BUTTON_QUOTE: 'Get your quote.',
		CYBER_MODULE_TALK_TO_LATU: 'Talk to Latú',
		CYBER_MODULE_TIERS_DETAIL_TITLE: 'Upgrade your cybersecurity!',
		CYBER_MODULE_TIERS_DETAIL_SUBTITLE: 'Check out the available plans below:',
		CYBER_MODULE_TIERS_DETAIL_LITE_TAG: 'Current Package',
		CYBER_MODULE_TIERS_DETAIL_LITE_TITLE: 'Latú Cyber Lite',
		CYBER_MODULE_TIERS_DETAIL_LITE_SUBTITLE:
			'Essential protection for your digital presence.',
		CYBER_MODULE_TIERS_DETAIL_LITE_PRICE_TEXT: 'Limited-time offer!',
		CYBER_MODULE_TIERS_DETAIL_LITE_PERKS_1:
			'Quarterly vulnerability assessment',
		CYBER_MODULE_TIERS_DETAIL_LITE_PERKS_2:
			'Cybersecurity and LGPD Compliance Checklist',
		CYBER_MODULE_TIERS_DETAIL_PLUS_TAG: 'Recommended',
		CYBER_MODULE_TIERS_DETAIL_PLUS_TITLE: 'Latú Cyber Plus',
		CYBER_MODULE_TIERS_DETAIL_PLUS_SUBTITLE:
			'Total security and expert guidance.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_BUTTON_QUOTE: 'Get a quote',
		CYBER_MODULE_TIERS_DETAIL_PLUS_BUTTON_BOOK:
			'The price of this plan is customized.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_1:
			'Everything that is included in the Lite plan.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_2: 'Cyber Insurance Protection.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_3: 'Monthly Vulnerability Assessment.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_4: 'Phishing Simulation and Testing.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_5: 'Access to Cybersecurity Experts.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_6:
			'Incident Response Management, 24/7.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_7:
			'Firewall, Antivirus, and Data Backup included for free.',
		CYBER_MODULE_CONTACT_BANNER_TITLE:
			'How would you like to contact our team?',
		CYBER_MODULE_CONTACT_BANNER_SUBTITLE:
			"We're here to help! Choose the best way to contact us:",
		CYBER_MODULE_REPORT_TITLE: 'Cyber Assessment.',
		CYBER_MODULE_REPORT_SUBTITLE: 'Cybersecurity assessment history',
		CYBER_MODULE_REPORT_TEXT_1:
			'Access the reports generated from the assessments conducted by',
		CYBER_MODULE_REPORT_TEXT_2: 'Latú Sonar.',
		CYBER_MODULE_REPORT_BANNER_TITLE: 'Analyzed resources.',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_1: 'You have an.',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_2: 'ongoing assessment.',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_3:
			'Soon, you will be able to view the analyzed resources',
		CYBER_MODULE_REPORT_COLUMN_DATE: 'Report date.',
		CYBER_MODULE_REPORT_COLUMN_SCORE: 'Company score.',
		CYBER_MODULE_REPORT_COLUMN_VULNERABILITIES: 'Number of vulnerabilities.',
		CYBER_MODULE_REPORT_COLUMN_DISCLAIMER:
			'If you want to cancel your periodic assessments, please contact us.',
		CYBER_MODULE_REPORT_COLUMN_RISK_LOW: 'Low risk',
		CYBER_MODULE_REPORT_COLUMN_RISK_MEDIUM: 'Medium risk',
		CYBER_MODULE_REPORT_COLUMN_RISK_HIGH: 'High Risk',
		CYBER_MODULE_REPORT_COLUMN_VULNERABILITIES_LABEL: 'vulnerabilities',
		CYBER_MODULE_REPORT_COLUMN_UNDER_REVIEW: 'Under review',
		CYBER_PAGE_MENU: 'Cyber Assessment',
		ANNUAL_REVENUE_OPTION_1: 'Less than R$ 250.000',
		ANNUAL_REVENUE_OPTION_2: '250.000 - R$ 1.000.000',
		ANNUAL_REVENUE_OPTION_3: 'R$ 1.000.000 - R$ 5.000.000',
		ANNUAL_REVENUE_OPTION_4: 'Over R$ 5.000.000',
		COMPANY_ACTIVITY_OPTION_1: 'Health',
		COMPANY_ACTIVITY_OPTION_2: 'Financial Services',
		COMPANY_ACTIVITY_OPTION_3: 'Manufacturing',
		COMPANY_ACTIVITY_OPTION_4: 'Others',
		CAPITAL_RAISED: 'Capital raised',
		FINANCING_OBTAINED: 'Financiamento Obtido',
		ADDITIONAL_INSTRUCTIONS_SECTION_TITLE: 'Additional instructions',
		ADDITIONAL_INSTRUCTIONS_SECTION_SUBTITLE:
			'If you have additional instructions, please use the field below:',
		ADDITIONAL_INSTRUCTIONS_SECTION_PLACEHOLDER: 'Write here.',
		ADDITIONAL_INSTRUCTIONS_SECTION_BUTTON: 'Finish',
		ADDITIONAL_INSTRUCTIONS_MODAL_TITLE: 'Information about your budget!',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_1: 'We noticed that you added',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_2: 'additional instructions',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_3:
			'to the insurance request. However, you are eligible to receive an automated quote. Please',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_4: 'review the provided quote;',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_5:
			"if it doesn't meet your specific instructions, don't worry,",
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_6:
			'our team will contact you shortly.',
		ADDITIONAL_INSTRUCTIONS_MODAL_BUTTON: 'Understood',
		NDA_CTA: 'Click here to download our NDA.',
		USER_TYPE_SELECTION_PAGE_TOOLTIP: '---',
		TAX_ID_FIELD_TOOLTIP_INFO: 'The active fields can be edited.',
		TAX_ID_FIELD_COMPANY_NAME_LABEL: 'Company Name:',
		TAX_ID_FIELD_COMPANY_CREATION_DATE_LABEL:
			'When did the company start its operations?',
		TAX_ID_FIELD_COMPANY_ADDRESS_TITLE: 'Company’s address',
		TAX_ID_FIELD_COMPANY_ADDRESS_STREET_LABEL: 'Street',
		TAX_ID_FIELD_COMPANY_ADDRESS_CITY_LABEL: 'City',
		TAX_ID_FIELD_COMPANY_ADDRESS_NUMBER_LABEL: 'Number',
		TAX_ID_FIELD_COMPANY_ADDRESS_STATE_LABEL: 'State',
		TAX_ID_FIELD_COMPANY_ADDRESS_DETAIL_LABEL: 'Detail',
		TAX_ID_FIELD_COMPANY_ADDRESS_ZIP_CODE_LABEL: 'ZIP code',
		TAX_ID_FIELD_COMPANY_ADDRESS_NEIGHBORHOOD_LABEL: 'Neighborhood',
		BROKER_POLICY_ISSUED: 'Visualizar apólice',
		BROKER_IPAF_IN_PROGRESS: 'Formulário em andamento',
		BROKER_IPAF_EXPIRED: 'Formulário expirado',
		BROKER_QUOTING_IN_PROGRESS: 'Trabalhando em cotação',
		BROKER_QUOTE_AWAITING_SELECTION: 'Cotação pendente de seleção',
		BROKER_QUOTE_EXPIRED: 'Cotação expirou',
		BROKER_QUOTE_REJECTED: 'Cotação não foi aceita',
		BROKER_REJECTED: 'Cotação não foi aceita',
		BROKER_ISSUING_POLICY: 'Elaborando a apólice',
		BROKER_POLICY_EXPIRED: 'Apólice vencida',
		BROKER_POLICY_PENDING_PAYMENT: 'Pagamento do seguro pendente',
		BROKER_POLICY_TO_RENEW: 'Renove a apólice',
		BROKER_POLICY_PENDING_SIGNATURE: 'Assinatura pendente',
		BROKER_MONTH_SLIDER_RECEIVED: 'NF recebida',
		BROKER_MONTH_SLIDER_PENDING: 'NF pendente',
		BROKER_MONTH_SLIDER_OPEN: 'Em aberto',
		BROKER_MOVEMENT_DELAYED: 'Atrasado',
		BROKER_MOVEMENT_PAID: 'Pago',
		BROKER_MOVEMENT_PENDING: 'Aguardando',
		BROKER_FISCAL_NOTE_APPROVED: 'Aprovado',
		BROKER_FISCAL_NOTE_PENDING: 'NF pendente',
		BROKER_FISCAL_NOTE_WAITING_APPROVAL: 'Em revisão',
		BROKER_FISCAL_NOTE_NEED_ACTION: 'NF pendente',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_TITLE:
			'Ready to complete your questionnaire?',
		ONE_PAGE_IPAF_MODAL_ONE_ACTION: 'Complete questionnaire',
		ONE_PAGE_IPAF_MODAL_SECOND_ACTION: 'Review data',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_SUBTITLE:
			'Carefully review your answers now to avoid future delays in the quoting process.',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_BUTTON: 'Confirm and Proceed',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_CANCEL: 'Review Answers',
		ONE_PAGE_FINISH: 'Finish',
		ONE_PAGE_NEXT: 'Save and continue',
		SHARE_IPAF_BUTTON: 'Share',
		ONE_PAGE_ANSWERS_PENDING_INFO:
			'There are pending questions that need to be answered before we can provide an insurance quote for your company. Please answer them before proceeding.',
		DATA_CAPITAL_RAISED_A: 'Capital Raised',
		DATA_CAPITAL_RAISED_B: 'Debt Raised',
		PENDING_PAYMENT_BANNER_TITLE:
			"Don't forget to make your insurance payment!",
		PENDING_PAYMENT_BANNER_INFO:
			'Your policy will become active only after the first installment is paid.',
		PAY_NOW: 'Pay the current invoice.',
		INVALID_TAX_ID: 'Invalid tax identification',
		EMPLOYS_TAG_FULL_TIME: 'Full time',
		EMPLOYS_TAG_HALF_TIME: 'Half time',
		EMPLOYS_TAG_THIRD_TIME: 'Third party',
		COMPANY_SHAREHOLDER_ADD_BUTTON_TEXT: 'Add customers',
		SHAREHOLDER_NAME_LABEL: "Shareholder's name",
		SHAREHOLDER_NAME_PLACEHOLDER: 'Customer name',
		SHAREHOLDER_PERCENTAGE_LABEL: 'Distribution percentage',
		SHAREHOLDER_BUTTON_TO_ADD: 'Add one more',
		SHAREHOLDER_BUTTON_TO_SAVE: 'Save',
		COMPANY_SHAREHOLDER_EDIT_TEXT: 'Edit',
		INDICATE_BILLING_PERCENTAGE_BUTTON: 'Indicate the billing percentage',
		INDICATE_INDUSTRY_CUSTOMERS: 'Indicate your clients activities',
		LIST_ACTIVITY_DATA_PROCESSING: 'Data Processing',
		LIST_ACTIVITY_SOFTWARE_DEVELOPMENT_INTERNAL:
			'Software Development (Ineternal)',
		LIST_ACTIVITY_SOFTWARE_DEVELOPMENT_EXTERNAL:
			'Software Development (Third Party)',
		LIST_ACTIVITY_CONSULTING_PLANNING: 'Consulting / Planning',
		LIST_ACTIVITY_SYSTEM_INSTALLATION_MAINTENANCE:
			'System Installation / Maintenance',
		LIST_ACTIVITY_WEBSITE_DEVELOPMENT_DESIGN_MAINTENANCE:
			'Website Development, Design, and Maintenance',
		LIST_ACTIVITY_WEB_HOSTING: 'Web Hosting',
		LIST_ACTIVITY_E_COMMERCE: 'E-Commerce',
		LIST_ACTIVITY_TRAINING_EDUCATIONAL_SERVICES:
			'Training / Educational Services',
		LIST_ACTIVITY_PAYMENT_PROCESSING: 'Payment Processing',
		LIST_ACTIVITY_HARDWARE_DEVELOPMENT: 'Hardware Development',
		LIST_ACTIVITY_HARDWARE_MAINTENANCE: 'Hardware Maintenance',
		LIST_ACTIVITY_OTHERS: 'Others',
		BUTTON_SAVE_ACTIVITIES: 'Save',
		COPY_ERROR_SUM_MUST_BE_100: 'The sum can’t exceed 100%',
		LIST_ROLES_FOUNDER: 'Founder',
		LIST_ROLES_C_LEVEL_EXECUTIVE: 'C-level executive',
		LIST_ROLES_DIRECTOR: 'Director',
		LIST_ROLES_MANAGER: 'Manager',
		LIST_ROLES_SPECIALIST_ANALYST: 'Specialist / Analyst',
		LIST_ROLES_OTHER: 'Other',
		LIST_DEGREES_MASTERS: "Master's degree",
		LIST_DEGREES_HIGHER_EDUCATION_COMPLETED: 'Higher education completed',
		LIST_DEGREES_HIGH_SCHOOL: 'High school',
		LIST_DEGREES_TECHNICAL_COURSE: 'Technical course',
		LIST_DEGREES_OTHER: 'Other',
		REVENUE_SECTION_TITLE_1: 'Full name',
		REVENUE_SECTION_PLACEHOLDER_1: 'Type the full name',
		REVENUE_SECTION_TITLE_2: 'Role',
		REVENUE_SECTION_PLACEHOLDER_2: 'Select the Role',
		REVENUE_SECTION_TITLE_3: 'Academic background',
		REVENUE_SECTION_PLACEHOLDER_3: 'Select academic background',
		REVENUE_BUTTON_ADD: 'Add one more',
		REVENUE_BUTTON_SAVE: 'Save',
		REVENUE_SECTION_ERROR_1: 'Full name is required',
		REVENUE_SECTION_ERROR_2: 'Role is required',
		REVENUE_SECTION_ERROR_3: 'Academic background is required',
		EDUCATION_LABEL: 'Education',
		COMPANY_STRUCTURE_DOCUMENT_LABEL: 'Tax ID',
		COMPANY_STRUCTURE_OPERATIONAL_LABEL: 'Operational',
		SELECTED_LABEL: 'Selected',
		REGISTER_CHILD_USER_PLACEHOLDER_FIRST_NAME: 'First name',
		REGISTER_CHILD_USER_PLACEHOLDER_LAST_NAME: 'Last name',
		ERROR_AUTH_PAGE_TITLE: 'Oops, an error was encountered!',
		ERROR_AUTH_PAGE_INTRO:
			'We encountered a problem while creating your account. Our team will contact you shortly with all the information for your account.',
		RESTORE_PASSWORD_PAGE_TITLE: 'Action Required: Please Reset your Password',
		RESTORE_PASSWORD_PAGE_INTRO:
			'For increased security, we are migrating our authentication system. As a result, you will be required to reset your password. This change is part of our ongoing efforts to enhance your account security and protect your data.',
		RESTORE_PASSWORD_PAGE_SUBTITLE: 'What You can Expect?',
		RESTORE_PASSWORD_PAGE_DESCRIPTION_1:
			'Seamless Transition: We are working to ensure that the transition is as smooth as possible, with minimal disruption to your service.',
		RESTORE_PASSWORD_PAGE_DESCRIPTION_2:
			'Improved Security: Resetting your password will help keep your account safe and secure.',
		RESTORE_PASSWORD_PAGE_BUTTON: 'Reset Password',
		INSURANCE_CERTIFICATE_BUTTON: 'Insurance Certificate',
		SHARE_CERTIFY_TITLE: 'Share Statement',
		SHARE_CERTIFY_DESCRIPTION:
			'Latú will generate a document for you to share with your clients, suppliers, or interested parties. Select the policies for which you wish to create the statement.',
		SHARE_CERTIFY_DOWNLOAD: 'Download',
		SHARE_CERTIFY_BUTTON: 'Send e-mail',
		INPUT_EMAIL_PLACEHOLDER: 'yourclient@company.com',
		INPUT_EMAILS_LIST_PLACEHOLDER:
			'Enter one or more email addresses, separated by commas.',
		ERROR_LIST_EMAIL_INVALID:
			'The format of some emails is incorrect and the mail could not be sent.',
		CERTIFY_SHARED_SUCCESS: 'Statement shared successfully',
		BILLING_USER_SECTION_TITLE: 'Billing email',
		BILLING_USER_SECTION_DETAIL:
			'This is the email address we will use to send your invoices and payment information. If the email is not registered, only the policyholder will receive the payment emails.',
		BILLING_USER_PLACE_HOLDER: 'email@yourcompany.com',
		BILLING_USER_SECTION_EDIT_CTA: 'Edit email',
		BILLING_USER_SECTION_ADD_CTA: 'Add email',
		BILLING_EDIT_TITLE: 'Enter your new billing email:',
		BILLING_MODAL_EDIT_CTA: 'Update email',
		BILLING_CANCEL_CTA: 'Cancel',
		BILLING_ADD_EMAIL_SUCCESS: 'Billing email updated!',
		BILLING_ADD_EMAIL_SUCCESS_SUBTITLE:
			'From now on, you will receive all billing and payment information at this new email:',
		BILLING_ADD_EMAIL_SUCCESS_CTA: 'Understood',
		NOT_FOUND_ACCOUNT_TITLE_1: 'Your email',
		NOT_FOUND_ACCOUNT_TITLE_2: 'is not associated with a Latú Seguros account.',
		NOT_FOUND_ACCOUNT_INTRO_1:
			'If your company is already a client, request your administrator to grant you access to your corporate account.',
		NOT_FOUND_ACCOUNT_INTRO_2:
			"If you're not yet a Latú Seguros client, discover how to effectively and reliably protect your company.",
		NOT_FOUND_ACCOUNT_BUTTON: 'Create your account',
		INVITE_SUCCESS_RE_SEND_INFO: 'The invitation has been successfully resent.',
		SEND_PAYMENT_VOUCHER_BUTTON: 'Send the payment slip to your customer!',
		INFO_IPAF_QUESTION_PENDING_TO_FILL: 'There are still unanswered questions.',
		MOBILE_IPAF_INFO_TITLE: 'Enhanced experience in the web version!',
		MOBILE_IPAF_INFO_TEXT:
			'Open the form on our web version and enjoy the simplicity and speed of entering your information!',
		MOBILE_IPAF_INFO_BUTTON: 'Ok, got it.',
		URL_INVALID: 'Url no valida',
		ACCOUNT_PENDING_ACTIVATION_TITLE: 'Account Approval Pending',
		ACCOUNT_PENDING_ACTIVATION_INTRO:
			'Thank you for registering with our broker portal. We are currently verifying your information to provide you with access to our quoting system. This process should be completed within 10 days. If you have any questions or if more than 10 days have passed, please contact us at contato@latuseguros.com or via WhatsApp at',
		ACCOUNT_PENDING_ACTIVATION_BTN: 'Explore Latú Seguros',
		COMPANY_ALREADY_HAS_AN_IPAF_TITLE: 'The company is already registered!',
		COMPANY_ALREADY_HAS_AN_IPAF_1:
			'The company you are trying to quote is already registered under the insurance broker',
		COMPANY_ALREADY_HAS_AN_IPAF_2:
			'To obtain a quote, please contact them using the following email:',
		COMPANY_ALREADY_HAS_AN_IPAF_3:
			'If you believe this is an error and the company should not be registered to the broker company, please email us at',
		DAYS_LEFT: 'days',
		BROKER_MONTH_SLIDER_APPROVED: 'Aprovado',
		BROKER_MONTH_SLIDER_NEED_ACTION: 'Enviar novamente',
		BROKER_MONTH_SLIDER_WAITING_APPROVAL: 'Aguardando Aprovação',
		START_PRE_IPAF: 'Save and continue',
		SUCCESS_SCREEN_1_TITTLE: 'Questionnaire completed successfully!',
		SUCCESS_SCREEN_1_SUBTITTLE:
			'Your quote is already in progress and you will be notified as soon as it is available.',
		SUCCESS_SCREEN_1_STEPS_A_TITLE: 'STEP 1',
		SUCCESS_SCREEN_1_STEPS_A_SUBTITLE: ' Data collection',
		SUCCESS_SCREEN_1_STEPS_B_TITLE: 'CURRENT STEP',
		SUCCESS_SCREEN_1_STEPS_B_SUBTITLE: 'Data analysis',
		SUCCESS_SCREEN_1_STEPS_C_TITLE: 'STEP 3',
		SUCCESS_SCREEN_1_STEPS_C_SUBTITLE: 'Quote presentation',
		SUCCESS_SCREEN_1_STEPS_D_TITLE: 'STEP 4',
		SUCCESS_SCREEN_1_STEPS_D_SUBTITLE: 'Active coverage',
		SUCCESS_SCREEN_1_BUTTON_FROM_LINK: 'Go to Latú Seguros',
		SUCCESS_SCREEN_1_BUTTON_FROM_USER_APP: 'Close',
		SUCCESS_SCREEN_1_BUTTON_FROM_BROKER_APP: 'Close',
		SUCCESS_SCREEN_1_REMAINING_DAYS_INFO_A: '',
		SUCCESS_SCREEN_1_REMAINING_DAYS_INFO_B:
			'Thanks for the information, we will start working on a quote right now.',
		IPAF_LISTENER_TITLE_GUEST:
			'Seu cliente realizou algumas alterações. Gostaria de atualizar o formulário e visualizar todas as modificações?',
		IPAF_LISTENER_TITLE_BROKER:
			'Seu corretor realizou algumas alterações. Gostaria de atualizar o formulário e visualizar todas as modificações?',
		IPAF_LISTENER_SUBTITLE:
			'Ao confirmar a atualização, suas respostas não salvas serão descartadas e o formulário será atualizado para a versão mais atual',
		TITLE_MODAL_FINISH_NOTIFICATION: 'The questionnaire has been completed!',
		TEXT_MODAL_FINISH_NOTIFICATION:
			'We will redirect you to the following page to view the next steps in your journey.',
		WARNING_INFO_FINISH_NOTIFICATION_1:
			'To view all the responses to your risk questionnaire, go to: ',
		WARNING_INFO_FINISH_NOTIFICATION_2: ' Taskboard > Dashboard.',
		ACTION_FINISH_NOTIFICATION: 'Understood',
		WARNING_INFO_FINISH_NOTIFICATION_TO_GUEST:
			'Seu broker entrará em contato com você assim que a cotação estiver pronta.',
		INITIAL_QUESTIONS_TITLE: 'Initial Questions',
		INITIAL_QUESTIONS_SUBTITLE:
			'This information is important to generate the most accurate questionnaire for your business.',
		EXIT_IPAF_LINK: 'Exit',
		IPAF_HEADER_TITLE: 'Insurance Form',
		POLICY_DETAIL_PENDING_SIGNATURE:
			'Seu cliente tem que assinar a proposta de seguro {{insurance_name}}! Enviamos um email diretamente a ele.',
		SIGNATARIO_EDIT_TOAST_SUCCESS:
			'Dados do signatário foram atualizados com sucesso!',
		ADMIN_EDIT_TOAST_SUCCESS:
			'Dados do administrador da conta foram atualizados com sucesso!',
		TITLE_MODAL_REJECT_IPAF:
			'Quote denied for not meeting our acceptance policy',
		TEXT_MODAL_REJECT_IPAF: 'You may try to resubmit this request in 3 months.',
		TEXT_MODAL_WARNING_INFO_1:
			'If you have any questions or disagree with our decision, please contact Latú support at:',
		REJECT_MODAL_PRIMARY_ACTION: ' Go to the homepage',
		REJECT_MODAL_SECONDARY_ACTION: 'Register another company',
		QUOTE_SUBJECTIVITIES_TITLE: 'Subjectivities',
		EXCLUSIONS_GENERIC_INFO_BROKER:
			"For a detailed description of coverages and exclusions, please refer to the product's general conditions.",
		EXCLUSIONS_GENERIC_INFO_USER:
			"For a detailed description of coverages and exclusions, please refer to the product's general conditions.",
		MULTI_URL_INVALID: 'Enter a valid URL',
		DONT_HAVE_URL: 'Doesn’t have a URL',
		CHECK_DONT_HAVE_URL: 'I don’t have a website',
		ADD_NEW_URL: 'Add another URL',
		LABEL_PRODUCT_CARD_SELECTION_APPROVED: 'Disponível para subscrição',
		LABEL_PRODUCT_CARD_SELECTION_REJECTED: 'Fora da política de risco',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_QUOTING: 'Apólice vigente',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_BEING_QUOTED: 'Cotação em andamento',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_POLICY_ANOTHER_BROKER:
			'Carta de nomeação',
		SUCCESS_MESSAGE: 'Questionnaire successfully completed!',
		CHECK_STATUS: 'Check the current status of your quote requests below:',
		UNDER_REVIEW:
			'Under review! You will be notified by your broker within 72 hours.',
		EXIT: 'Exit',
		DATA_COLLECTION: 'Data Collection',
		RISK_ANALYSIS: 'Risk Analysis',
		QUOTE_AVAILABLE: 'Quote Available',
		ACTIVE_COVERAGE: 'Active Coverage',
		UNDER_RISK_ANALYSIS: 'Under risk analysis',
		FOR_QUESTIONS: 'For questions, contact us via',
		TEXT_OR_BY_EMAIL_AT: 'or by email at',
		ERROR_SUCCESS_PAGE_TITLE: 'Não podemos apresentar cotação para este risco',
		ERROR_SUCCESS_PAGE_SUB_TITLE:
			'Confira o status atual das suas solicitações de cotação abaixo:',
		EMAIL_REGISTERED_ANOTHER_COMPANY:
			'O e-mail já tem uma conta, por favor tente com outro e-mail.',
		EO_DISCLAIMER_1: 'Claims-Made Insurance',
		EO_DISCLAIMER_2:
			'The Insurer shall pay the Insured for losses suffered as a result of Claims made against them by Third Parties seeking to hold them.',
		EO_BASIC_COVERAGES_TITLE: 'Basic Coverages',
		EO_ADDITIONAL_COVERAGES_TITLE: 'Additional Coverages',
		EO_EXTENSIONS_COVERAGES_TITLE: 'Coverage Extensions',
		REFRESH_DEPLOY_TITLE: 'Atualizações disponíveis!',
		REFRESH_DEPLOY_INFO:
			'Aplicamos melhorias para uma experiência ainda melhor. Recarregue a página para acessar as novidades.',
		REFRESH_DEPLOY_ACTION: 'Atualizar agora',
	},
};
